import { GuaranteeModalProps } from './GuaranteeModal.interface';
import { Modal } from '@axafr-btc-ds/modal';
import styles from './GuaranteeModal.module.css';
import { Typography } from '@axafr-btc-ds/typography';
import { RenderIf } from 'components/render-if';

const GuaranteeModal = ({
    isOpen,
    onClose,
    title,
    icon,
    data,
    id,
}: GuaranteeModalProps) => {
    return (
        <Modal
            isContentReady={ true }
            isRounded={ true }
            isOpen={ isOpen }
            isHeaderHidden={ true }
            onClose={ onClose }
            describedBy='description'
            closeButtonAriaLabel='Fermer la fenêtre'
            key={ id }
        >
            <span className={ styles.header }>
                { icon }
                <Typography variant='title2' className={ styles.title } component='p'>
                    { title }
                </Typography>
            </span>
            <span className={ styles.body }>
                { Object.entries(data).map(([ key, value ]) => {
                    return (
                        <span key={ key }>
                            <RenderIf value={ key !== 'Footer' }>
                                <Typography variant='body2' component='p' bodyFontWeight='600' className={ styles.notMargin }>
                                    { key }
                                </Typography>
                            </RenderIf>
                            { value.split('\n').map((segment: string, index: number) => {
                                return (
                                    <Typography key={ id || '' + index } variant='body2' component='span' bodyFontWeight='400' className={ styles.notMargin }>
                                        { segment }<br />
                                    </Typography>
                                );
                            }) }
                        </span>
                    );
                }) }
            </span>
        </Modal>
    );
};

export default GuaranteeModal;
